<template>
  <v-sheet tile color="#ffffff" >
    <v-container>
      <v-form v-model="isValid">
        <div>
          <div v-for="signUpField in this.fields" :signUpField="signUpField" v-bind:key="signUpField.key">
            <v-text-field background-color="#F4F7FC" filled light :required="signUpField.required"
                          :rules="signUpField.rules"
                          :label="signUpField.label"
                          :name="signUpField.name"
                          autocorrect="off" autocapitalize="none"
                          :append-icon="signUpField.type == 'password' ? (show_new_pass? 'visibility' : 'visibility_off'): ''"
                          :type="signUpField.type == 'password' ? (show_new_pass? 'text': 'password') : signUpField.type"
                          @click:append="show_new_pass = !show_new_pass"
                          v-model="user_record[signUpField.key]"
                          @input="resetError"/>
          </div>
        </div>
      </v-form>
      <div class="login-helper" align="center">
      </div>
      <br/>
      <div class="error white--text pa-2 rounded" v-if="error">
        {{ error }}
      </div>
      <br/>
      <div class="buttons-container">
        <v-btn large outlined color="primary" v-on:click="signIn">Sign In</v-btn>
        <v-btn large  color="primary" v-on:click="signUp" :disabled="!isValid">Create account</v-btn>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
  import Vue from 'vue';
  import {AmplifyEventBus} from 'aws-amplify-vue';


  export default {
    name: 'SignUp',
    props: ['user'],
    data: function () {
      return {
        'user_record': {
          'username': '',
          'email': '',
          'password': '',

        },
        show_new_pass: false,
        error: '',
        isValid: false,
      }
    },
    computed: {
      fields() {
        return [
          {
            label: 'Full Name',
            key: 'name',
            required: true,
            type: 'string',
            name: 'name',
            rules: [v => !!v || 'Full Name is required']
          },
          {
            label: 'Email',
            key: 'email',
            required: true,
            type: 'string',
            name: 'email',
            rules: [
              v => !!v || 'Email is required',
              v => (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'Email must be valid'
            ]
          },
          {
            label: 'Password',
            key: 'password',
            required: true,
            type: 'password',
            name: 'password',
            rules: [
              v => !!v || 'Password is required',
              v => v.length > 7 || 'Min length 8 characters']
          },
        ]
      },
    },
    methods: {
      resetError: function () {
        this.error = ''
      },
      signUp: function () {
        var user = {
          'username': this.user_record.email.toLowerCase(),
          'password': this.user_record.password,
          'attributes': {
            'name': this.user_record.name,
            'email': this.user_record.email.toLowerCase()
          }
        }
        this.$store.dispatch('startForcedLoad')
        this.$Amplify.Auth.signUp(user)
          .then(data => {
            AmplifyEventBus.$emit('localUser', data.user)
            this.$store.dispatch('stopForcedLoad')
            if (data.userConfirmed === false) {
              return AmplifyEventBus.$emit('authState', 'confirmSignUp');
            }
            return AmplifyEventBus.$emit('authState', 'signedOut')
          })
          .catch(e => {
            this.$store.dispatch('stopForcedLoad')
            this.setError(e)
          });

      },
      signIn: function () {
        AmplifyEventBus.$emit('authState', 'signedOut')
      },
      setError: function (e) {
        this.error = e.message || e;
      },
    }
  }
</script>
<style lang="scss" scoped>
  .buttons-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 1rem;
    grid-row-gap: 1rem;
    @media screen and (max-width: 599px) {
      grid-template-columns: 1fr
    }
  }

  .contain-image {
    & img {
      width: 2rem;
      height: 2rem;
    }
  }

  .login-helper {
  }
</style>



// WEBPACK FOOTER //
// src/Auth/SignUp.vue